import type { FeatureRoute } from '../types';
import { GoodsReceiptDetailPage } from './GoodsReceiptDetailPage';
import { PurchaseOrderDetailPage } from './PurchaseOrderDetailPage';
import { PurchaseOrderFormPage } from './PurchaseOrderFormPage';
import { PurchasesHubPage } from './PurchasesHubPage';
import { ReceiveGoodsPage } from './ReceiveGoodsPage';
import { SupplierBillDetailPage } from './SupplierBillDetailPage';
import { SupplierBillFormPage } from './SupplierBillFormPage';

/** Routes owned by this feature (paths are relative to the app root, e.g. 'customers/:id'). */
export const routes: FeatureRoute[] = [
  { path: 'purchases', element: <PurchasesHubPage /> },
  { path: 'purchases/orders/new', element: <PurchaseOrderFormPage /> },
  { path: 'purchases/orders/:id', element: <PurchaseOrderDetailPage /> },
  { path: 'purchases/orders/:id/edit', element: <PurchaseOrderFormPage /> },
  { path: 'purchases/receipts/new', element: <ReceiveGoodsPage /> },
  { path: 'purchases/receipts/:id', element: <GoodsReceiptDetailPage /> },
  { path: 'purchases/bills/new', element: <SupplierBillFormPage /> },
  { path: 'purchases/bills/:id', element: <SupplierBillDetailPage /> },
];
